import http from "./httpService";

class HomepageService {
  async getLessons(params) {
    const url = http.getUrlWithParams("/lessons", {
      ...params,
    });
    return await http.get(url);
  }
}

export default new HomepageService();
